import { MapTo } from '@adobe/aem-react-editable-components';
import ApplicationEsign, { ApplicationEsignEditConfig } from './ApplicationEsign';

export default MapTo('cob-corp-acquisition/components/creditonebank/application-esign')(ApplicationEsign, ApplicationEsignEditConfig);